const { default: API } = require("../api/API");

function getOpeningHours({ business_id, body = {} }) {
  return new Promise((resolve, reject) => {
    API.post(`personal/business/${business_id}/opening-hours`, body).then(
      resolve,
      reject
    );
  });
}

export default getOpeningHours;
